import { useEffect } from 'react';
import { isSafari } from '@wix/editor-elements-common-utils';
import { addFocusPolyfill } from './safariPolyfill';

export const useSafariPolyfill = () => {
  useEffect(() => {
    // @ts-expect-error
    let listeners;
    if (isSafari()) {
      listeners = addFocusPolyfill();
    }
    return () => {
      if (isSafari()) {
        // clear listerners
        window.removeEventListener(
          'mousedown',
          // @ts-expect-error
          listeners!.detectFaultyElementAndScheduleFix!,
          { capture: true },
        );
        // @ts-expect-error
        window.removeEventListener('click', listeners!.fulfillDeferments, {
          capture: true,
        });
        // @ts-expect-error
        window.removeEventListener('mouseup', listeners!.captureEvent, {
          capture: true,
        });
        // @ts-expect-error
        window.removeEventListener('click', listeners!.captureEvent, {
          capture: true,
        });
      }
    };
  }, []);
};
